<template>
  <div style="display: inline-block;">
    <slot v-bind="{ mailTo }">
      <SecondaryBtn v-bind="$attrs" v-on="$listeners" :href="mailTo" color="info" icon="forward_to_inbox">
        Contact support about this
      </SecondaryBtn>
    </slot>
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  const authenticate = createNamespacedHelpers('authenticate')

  export default {
    props: {
      userLogs: Array,
      message: String,
      displayMessage: String,
      processInstanceId: String,
    },
    computed: {
      ...authenticate.mapGetters(['username']),
      mailTo() {
        const TECH_SUPPORT = 'envirodata-techsupport@hatfieldgroup.com'
        const NEW_LINE = '\n'
        let route = window.location.href
        let errorLogs = this.userLogs && JSON.stringify(this.userLogs.map(ul => JSON.stringify(ul) + NEW_LINE))
        let body = encodeURIComponent(`[Write a custom message or hit send.]
        
        --------------------------------------
        Username: ${this.username}
        DisplayMessage: ${this.displayMessage || 'n/a'}
        PID: ${this.processInstanceId || 'n/a'}
        URL: ${route}
        Logs: ${errorLogs || 'n/a'}
        Message: ${this.message}`)

        return `mailto:${TECH_SUPPORT}?subject=EnviroData error&body=${body}`
      },
    },
  }
</script>